'use strict';

const _=require('pulsar-utils/dist-es6/_');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ScheduleWeekNavigatorDirective=class ScheduleWeekNavigatorDirective extends BaseControllerBackedDirective{
get templateUrl(){return'/templates/directives/scheduleWeekNavigatorDirective/scheduleWeekNavigatorTemplate'}
get objectBindings(){return['scheduleBounds','selectedWeek','timezone']}
get controller(){return ScheduleWeekNavigatorController}};let


ScheduleWeekNavigatorController=class ScheduleWeekNavigatorController{
static get $inject(){return['$state','dateService']}
constructor($state,dateService){
this._$state=$state;
this._dateService=dateService;
}

goToNow(){
if(this.isAtNow()){
return;
}

this._goToInterval(TimeInterval.fromPoint(this._dateService.now()));
}

goToNextWeek(){
if(this.isAtScheduleEnd()){
return;
}

this._goToInterval(this.selectedWeek.shift('weeks',1,this.timezone));
}

goToPreviousWeek(){
if(this.isAtScheduleStart()){
return;
}

this._goToInterval(this.selectedWeek.shift('weeks',-1,this.timezone));
}

isAtScheduleStart(){
return this.selectedWeek.contains(this.scheduleBounds.start);
}

isAtNow(){
return this.selectedWeek.contains(this._dateService.now());
}

isAtScheduleEnd(){
return this.selectedWeek.contains(this.scheduleBounds.end);
}

_goToInterval(interval){
this._$state.go('fdc.features.personalSchedule',{interval});
}};


module.exports=ScheduleWeekNavigatorDirective;
//# sourceMappingURL=scheduleWeekNavigatorDirective.js.map
